import { throttle } from '@cian/newbuilding-utils';

import { type FC, useCallback, useEffect, useRef, useState } from 'react';

import { Header as HeaderComponent } from 'shared/components/Header';
import { PikLogo } from 'shared/components/PikLogo';
import { ECallbackPlace } from 'shared/types/callback';

import { Callback } from '../Callback';
import { PikPhoneNumber } from '../PikPhoneNumber';

import { getPrevSiblingDistanceToTop } from './helpers';

export const Header: FC = () => {
  const [isHeaderFixed, setHeaderFixed] = useState(false);
  const headerRef = useRef<HTMLElement>(null);
  const headerHeight = headerRef.current ? headerRef.current.getBoundingClientRect().height : 0;
  const prevSiblingDistanceToTop = getPrevSiblingDistanceToTop(headerRef.current);
  const place = isHeaderFixed ? ECallbackPlace.BlockStickyTop : ECallbackPlace.HeadBlock;

  const handleFixHeader = useCallback(() => {
    const header = headerRef.current;

    /* istanbul ignore next */
    if (!header) {
      return;
    }

    const windowYOffset = window.pageYOffset;

    if (windowYOffset > prevSiblingDistanceToTop + headerHeight) {
      setHeaderFixed(true);
    } else {
      setHeaderFixed(false);
    }
  }, [headerHeight, prevSiblingDistanceToTop]);
  const handleScroll = throttle(200, handleFixHeader);

  useEffect(() => {
    handleFixHeader();
    window.addEventListener('scroll', handleScroll);

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleFixHeader, handleScroll]);

  return (
    <HeaderComponent
      callback={<Callback place={place} />}
      isFixed={isHeaderFixed}
      logo={<PikLogo />}
      number={<PikPhoneNumber />}
      ref={headerRef}
    />
  );
};
